import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=04bd53c1"
import script from "./imprint.vue?vue&type=script&lang=js"
export * from "./imprint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports